// extracted by mini-css-extract-plugin
export var container = "_3v-0";
export var disabled = "_3v-4";
export var fullWidth = "_3v-3";
export var lined = "_3v-1";
export var selected = "_3v-5";
export var tab = "_3v-2";